export const PUSH_BATCH_SIZE = 100;
export const PULL_BATCH_SIZE = 300;
export var RemoteCollectionName;
(function (RemoteCollectionName) {
    RemoteCollectionName["QNA_NODE"] = "qna-node";
    RemoteCollectionName["QNA_NODE_USER"] = "qna-node-user";
})(RemoteCollectionName || (RemoteCollectionName = {}));
